import cloneDeep from 'lodash/cloneDeep'

export const state = {
    genres: [],
    activeObject: null,
}

export const getters = {
    activeGenres(state) {
        return state.genres
            .filter(genre => genre.status === 'open')
            .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0))
    },
}

export const mutations = {
    SET_GENRES(state, genres) {
        state.genres = genres
    },
    SET_ACTIVE(state, genre) {
        state.activeObject = cloneDeep(genre)
    },
}

export const actions = {}
